"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AccelerateConfiguration_1 = require("./_AccelerateConfiguration");
exports.PutBucketAccelerateConfigurationInput = {
    type: "structure",
    required: ["Bucket", "AccelerateConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        AccelerateConfiguration: {
            shape: _AccelerateConfiguration_1._AccelerateConfiguration,
            locationName: "AccelerateConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "AccelerateConfiguration"
};
//# sourceMappingURL=PutBucketAccelerateConfigurationInput.js.map